//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getStorage } from '@/js/utils';
const qaIcon = require('@/assets/loanBindCard/qaIcon@2x.png');
const qaIconKoo = require("@/assets/loanBindCard/qaIcon-koo@2x.png");
const step1 = require('@/assets/Repay/01@2x.png');
const step2 = require('@/assets/Repay/02@2x.png');
const step3 = require('@/assets/Repay/03@2x.png');
const step1Koo = require('@/assets/Repay/01-koo@2x.png');
const step2Koo = require('@/assets/Repay/02-koo@2x.png');
const step3Koo = require('@/assets/Repay/03-koo@2x.png');
const pic1 = require('@/assets/Repay/pic1@2x.png');
const pic2 = require('@/assets/Repay/pic2@2x.png');
const up = require('@/assets/Repay/up.png');
const upKoo = require('@/assets/Repay/up-koo.png');
const down = require('@/assets/Repay/down.png');
const downKoo = require('@/assets/Repay/down-koo.png');
const secondStep = require('@/assets/Repay/second-step.png');
const secondStepKoo = require('@/assets/Repay/second-step-koo.png');
export default {
    name: 'offlineRepayGuide',
    data() {
        return {
            amount: '',
            isCopyBtnShow: true,
            qaIcon,
            qaIconKoo,
            step1,
            step2,
            step3,
            step1Koo,
            step2Koo,
            step3Koo,
            pic1,
            pic2,
            up,
            upKoo,
            down,
            downKoo,
            secondStep,
            secondStepKoo,
            corporateAccount: {
                bankAccountName: '',
                bankAccount: '',
                bankName: '',
            },
            activeNames: [],
            themeType: '',
        };
    },
    components: {},
    computed: {
        accountInfo() {
            return [
                {
                    title: '还款金额(元)',
                    linkText: '复制金额',
                    value: this.amount,
                },
                {
                    title: '收款方户名(对公账户)',
                    linkText: '复制户名',
                    value: this.corporateAccount.bankAccountName,
                },
                {
                    title: '收款方账号',
                    linkText: '复制账号',
                    value: this.corporateAccount.bankAccount,
                },
                {
                    title: '开户行',
                    linkText: '复制开户行',
                    value: this.corporateAccount.bankName,
                },
            ];
        },
    },
    props: {
        realAmount: {
            required: true
        }
    },
    methods: {
        showToast(text) {
            this.$vux.toast.text(text, 'middle');
        },
        onCopy() {
            this.showToast('复制成功');
        },
        onError(e, value) {
            if (this.isApp) {
                // 理财app新版本
                window.PPDWebUI.FinancialService.copy(
                    {
                        copyContext: value,
                    },
                    () => {
                        this.showToast('复制成功');
                    },
                    () => {
                        this.showToast('您的手机浏览器暂不支持复制功能，请手动复制！');
                    }
                );
            } else {
                this.showToast('您的手机浏览器暂不支持复制功能，请手动复制！');
            }
        },
        collapseChange(activeNames) {
            if (activeNames.length) {
                this.sensorsRecord('h5_clk', {
                    tgt_event_id: 'h5_paycash_offline_open_info_button',
                    tgt_name: 'h5-paycash-线下还款页展开转账信息按钮',
                    url: location.href,
                    page: '还款-线下还款页',
                });
            }
        }
    },
    created() {
        const {
            themeType,
        } = this.$route.query;
        this.themeType = themeType;
        this.isApp =
            window.PPDWebUI &&
            window.PPDWebUI.os.inApp &&
            ['PPDLendApp', 'PPDLoanApp'].includes(window.PPDWebUI.os.channel);
        // const { amount } = this.$route.query;
        const offBankVo = getStorage('session', 'offBankVo');
        this.corporateAccount = Object.assign({}, this.corporateAccount, offBankVo);
        this.amount = this.realAmount;
        this.sensorsRecord('h5_element_imp', {
            tgt_event_id: 'h5_paycash_offline_guide',
            tgt_name: 'h5-paycash-线下还款引导页',
            url: location.href,
            page: '还款-线下还款引导页',
            param4: this.amount,
        });
    },
};
